var _rect, _polygon, _polygon2, _circle, _rect2, _polygon3, _polygon4, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polygon5, _path26, _polygon6, _path27, _path28, _circle3, _path29, _path30, _path31, _path32, _path33;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndrawProcessReGws7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 601.6,
    height: 630,
    viewBox: "0 0 601.6 630",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 756.96373,
    y: 195.50659,
    width: 1.67162,
    height: 109.19622,
    transform: "translate(-245.06837 491.48745) rotate(-46.40674)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "498.845 143.982 497.175 144.083 497.679 152.309 489.437 152.21 489.419 153.882 499.457 154.001 498.845 143.982",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "427.781 76.326 427.763 77.998 419.522 77.899 420.026 86.125 418.355 86.226 417.745 76.206 427.781 76.326",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 458.59956,
    cy: 115.10464,
    r: 9.19286,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 389.27378,
    y: 249.26889,
    width: 109.19622,
    height: 1.67162,
    transform: "translate(-349.25942 240.03057) rotate(-43.59326)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.815 154.001 113.853 153.882 113.834 152.21 105.593 152.309 106.097 144.083 104.427 143.982 103.815 154.001",
    fill: "#e6e6e6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "185.527 76.206 184.916 86.226 183.246 86.125 183.749 77.899 175.508 77.998 175.49 76.326 185.527 76.206",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.67187,
    cy: 115.10464,
    r: 9.19286,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M669.36429,325.54286H530.63571a7.53,7.53,0,0,1-7.52142-7.52143v-175.5A7.53,7.53,0,0,1,530.63571,135H669.36429a7.53,7.53,0,0,1,7.52142,7.52143v175.5A7.53,7.53,0,0,1,669.36429,325.54286ZM530.63571,136.67143a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H669.36429a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M588.45985,219.35842h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V179.562a3.76488,3.76488,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76072,3.76071v36.03569A3.76489,3.76489,0,0,1,588.45985,219.35842Z",
    transform: "translate(-299.2 -135)",
    fill: "#dbd901"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M647.79557,236.07271h-30.537a3.7649,3.7649,0,0,1-3.76072-3.76071V196.27631a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072V232.312A3.76489,3.76489,0,0,1,647.79557,236.07271Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600.15985,287.05128h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V247.25488a3.76489,3.76489,0,0,1,3.76071-3.76072h30.537a3.7649,3.7649,0,0,1,3.76072,3.76072v36.03569A3.76489,3.76489,0,0,1,600.15985,287.05128Z",
    transform: "translate(-299.2 -135)",
    fill: "#ff6584"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M893.27857,506H754.55a7.53005,7.53005,0,0,1-7.52143-7.52143v-175.5a7.53005,7.53005,0,0,1,7.52143-7.52143H893.27857A7.53,7.53,0,0,1,900.8,322.97857v175.5A7.53,7.53,0,0,1,893.27857,506ZM754.55,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H893.27857a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M847.73214,354.31786H800.09643a3.34286,3.34286,0,0,1,0-6.68572h47.63571a3.34286,3.34286,0,0,1,0,6.68572Z",
    transform: "translate(-299.2 -135)",
    fill: "#dbd901"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,386.075H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,403.625H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,421.175H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,438.725H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,456.275H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M871.13214,473.825H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.45,506H306.72143A7.53,7.53,0,0,1,299.2,498.47857v-175.5a7.53,7.53,0,0,1,7.52143-7.52143H445.45a7.53005,7.53005,0,0,1,7.52143,7.52143v175.5A7.53005,7.53005,0,0,1,445.45,506ZM306.72143,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H445.45a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M423.44834,356.89277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M423.44834,374.44277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M360.22223,384.43578h-30.537a3.76489,3.76489,0,0,1-3.76072-3.76071V344.63938a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072v36.03569A3.76488,3.76488,0,0,1,360.22223,384.43578Z",
    transform: "translate(-299.2 -135)",
    fill: "#dbd901"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1588,410.37848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1588,427.92848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1588,445.47848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1588,463.02848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M423.1588,480.57848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M497.89518,607.71863V571.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,497.89518,607.71863Z",
    transform: "translate(-299.2 -135)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89518,595.71863V559.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,508.89518,595.71863Z",
    transform: "translate(-299.2 -135)",
    fill: "#dbd901"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M645.78429,584.18843a9.07776,9.07776,0,0,1-2.39821-13.71145l-9.4656-69.18787,19.71756.9678,3.09564,67.48557a9.12692,9.12692,0,0,1-10.94939,14.446Z",
    transform: "translate(-299.2 -135)",
    fill: "#a0616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M656.34418,503.17871a3.70494,3.70494,0,0,1-1.5051,1.06441l-17.71963,6.76294a3.72283,3.72283,0,0,1-4.729-1.96465l-15.69629-35.27523a14.73962,14.73962,0,0,1-.7212-10.43132,14.33679,14.33679,0,0,1,10.91159-9.78216,13.67275,13.67275,0,0,1,5.89.08316,14.27981,14.27981,0,0,1,10.26305,8.92147l13.956,36.89A3.73032,3.73032,0,0,1,656.34418,503.17871Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.807 618.06 252.547 618.06 248.102 570.549 264.809 570.773 264.807 618.06",
    fill: "#a0616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H228.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,243.79024,614.55666Z",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.807 618.06 309.547 618.06 303.715 570.772 321.809 570.773 321.807 618.06",
    fill: "#a0616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M300.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H285.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,300.79024,614.55666Z",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M622.54889,736.23552l-19.25513-1.42578a4.50578,4.50578,0,0,1-4.16235-4.27051L594.838,641.80876a3.50008,3.50008,0,0,0-6.92481-.5332L570.002,728.68278a4.50575,4.50575,0,0,1-4.76709,3.582l-17.40576-1.39257a4.4995,4.4995,0,0,1-4.1189-4.93262L559.858,564.46306a4.49952,4.49952,0,0,1,5.43359-3.94922l61.406,13.34863a4.511,4.511,0,0,1,3.543,4.48145L627.38067,731.8322a4.5022,4.5022,0,0,1-4.489,4.416C622.77789,736.24821,622.66363,736.24333,622.54889,736.23552Z",
    transform: "translate(-299.2 -135)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.50339,
    cy: 269.88758,
    r: 24.56103,
    fill: "#a0616a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M567.59552,576.9152a21.96161,21.96161,0,0,1-7.2937-16.86621c0-35.30078,30.55566-114.168,31.51367-116.6289.0935-.59278.89966-.84864,5.12939-3.70606,4.23242-2.85937,10.335-3.29883,18.13941-1.30566a4.47911,4.47911,0,0,1,3.25,3.31836l1.4519,2.09765a3.49144,3.49144,0,0,0,2.02881,2.40625c6.29346,2.65137,26.29809,14.87793,19.48144,60.89161-6.33227,42.74316-8.90185,67.88086-9.71264,76.70507a4.49122,4.49122,0,0,1-4.07154,4.06543c-3.08569.27637-8.38183.64356-14.68945.64356C598.20172,588.5363,578.14654,586.56364,567.59552,576.9152Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M538.24736,563.83729a9.07771,9.07771,0,0,1,5.649-12.72182L574.58944,488.39l15.83345,11.79069-35.034,57.76251a9.12692,9.12692,0,0,1-17.14158,5.89414Z",
    transform: "translate(-299.2 -135)",
    fill: "#a0616a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M592.15633,502.454a3.7049,3.7049,0,0,1-1.8429.04517l-18.48219-4.25807a3.72282,3.72282,0,0,1-2.832-4.26646l6.62251-38.03759a14.73969,14.73969,0,0,1,5.21371-9.06366,14.33681,14.33681,0,0,1,14.51142-2.04255,13.67258,13.67258,0,0,1,4.84448,3.35107,14.27983,14.27983,0,0,1,3.55082,13.12686l-8.96734,38.40871A3.7303,3.7303,0,0,1,592.15633,502.454Z",
    transform: "translate(-299.2 -135)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M599.95291,427.0789a10.58407,10.58407,0,0,1-2.83917-9.3866c.85636-4.47943,1.35942-7.41039,1.45471-8.47667h0c.32608-3.64766-3.36133-6.60057-7.01009-7.07047-.1414-.01845-.25976-.03074-.35857-.03865.09288.09135.19279.18445.2804.267.693.65084,1.55573,1.46153,1.35064,2.29769-.12362.50327-.58364.86075-1.40663,1.09087-5.70622,1.59678-10.1009.13087-13.83068-4.61645a11.026,11.026,0,0,1-2.10511-4.598c-1.33593-6.5549,2.2239-12.14277,5.4458-15.67537,2.6567-2.91295,6.96354-6.44907,12.39419-6.75209,4.2234-.23583,9.24563,2.19448,10.74888,6.57423a8.15937,8.15937,0,0,1,6.36123-3.58618,14.662,14.662,0,0,1,8.15827,2.26914c11.90914,6.8219,17.02732,23.07258,11.17684,35.48763-3.68038,7.80914-11.65421,13.62273-20.80981,15.17209a10.39312,10.39312,0,0,1-1.7349.14668A10.11515,10.11515,0,0,1,599.95291,427.0789Z",
    transform: "translate(-299.2 -135)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M484.77874,765h195a1,1,0,0,0,0-2h-195a1,1,0,1,0,0,2Z",
    transform: "translate(-299.2 -135)",
    fill: "#3f3d56"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProcessReGws7);
export default __webpack_public_path__ + "static/media/undraw_process_re_gws7.4b524aac02b641713f995971a2a2645d.svg";
export { ForwardRef as ReactComponent };